
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/comparepeorates/privacy-policy",
      function () {
        return require("private-next-pages/comparepeorates/privacy-policy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/comparepeorates/privacy-policy"])
      });
    }
  